import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { toggleModal } from './actions';

const modalSelector = (state) => state.modal;

export const useModal = {
  state: () => {
    return useSelect(modalSelector);
  },
  actions: () => {
    return {
      toggleModal: useAction(toggleModal),
    };
  },
};
